/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Forhelp1Inputs */

const en_settings_forhelp1 = /** @type {(inputs: Settings_Forhelp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for help`)
};

/**
* | output |
* | --- |
* | "for help" |
*
* @param {Settings_Forhelp1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_forhelp1 = /** @type {((inputs?: Settings_Forhelp1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Forhelp1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_forhelp1(inputs)
});
export { settings_forhelp1 as "settings_forHelp" }